module.exports = "<p>\n  share-embed works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/share-map/share-embed/share-embed.component.html
// module id = ./src/app/components/popups/share-map/share-embed/share-embed.component.html
// module chunks = main